
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import IconDanger from '@components/icons/tag/icon-danger.svg';

@Component({
  name: 'car-health-aggregate-state',
  components: {
    IconDanger
  }
})
export default class CarHealthAggregateState extends Vue {
  @Prop()
  private aggregateState: String

  @Prop()
  private loading: boolean

  get aggregateFill() {
    if (this.loading) {
      return 'url(#oeamtc-gradient__neutral)'
    }
    switch(this.aggregateState) {
      case "UNPLUGGED": return 'url(#oeamtc-gradient__neutral)'
      case "RED": return 'url(#oeamtc-gradient__danger)'
      case "YELLOW": return 'url(#oeamtc-gradient__warning)'
      case "GREEN": return 'url(#oeamtc-gradient__success)'
    }
  }

  get iconHref() {
    if (this.loading) {
      return ''
    }
    switch(this.aggregateState) {
      case "UNPLUGGED": return '#oeamtc-symbol__close'
      case "RED": return '#oeamtc-symbol__close'
      case "YELLOW": return '#oeamtc-symbol__close'
      case "GREEN": return '#oeamtc-symbol__check'
    }
  }
}
